import { Button, Flex, Heading, Text, Image, Link } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { StarIcon } from '@chakra-ui/icons';
import { observer } from 'mobx-react';
import Container from '../../common/container';
import ProgressBar from '../../common/progressBar';
import AppImage from '../../assets/push-training-app.png';
import {
  PushInfo,
  getPushAppInfoFromApple,
} from '../../api/getPushAppInfoFromApple';
import { useStores } from '../../store/rootStore';
import {
  trackSendToAppDeepLinkButtonTapped,
  trackSendToAppDownloadButtonTapped,
  trackSendToAppPageView,
} from '../../utils/analytics';

const SendToApp = observer(() => {
  const [isContinueButtonBright, setIsContinueButtonBright] = useState(false);
  const [pushInfo, setPushInfo] = useState<PushInfo>({
    trackName: 'Treadmill Workout Push Training',
    averageUserRating: 4.9,
    userRatingCountForCurrentVersion: 590,
    artworkUrl512: AppImage,
  });

  const { createDeepLink } = useStores();

  setTimeout(() => {
    setIsContinueButtonBright(true);
  }, 10000);

  useEffect(() => {
    trackSendToAppPageView();
    getPushAppInfoFromApple().then((result) => {
      setPushInfo({
        trackName: result.trackName,
        averageUserRating: result.averageUserRating,
        userRatingCountForCurrentVersion:
          result.userRatingCountForCurrentVersion,
        artworkUrl512: result.artworkUrl512,
      });
    });
  }, []);

  const handleDeepLinkButtonClick = () => {
    const deepLink = createDeepLink();
    trackSendToAppDeepLinkButtonTapped(deepLink);
    const win = window.open(deepLink, '_blank');
    if (win) {
      win.focus();
    }
  };

  return (
    <Container>
      <ProgressBar currentPage="SendToApp" />
      <Heading textAlign={'center'} marginTop={'5'}>
        You're all set!
      </Heading>
      <Link
        href="/download?ct=webOnboarding"
        _hover={{ textDecoration: 'none' }}
        onClick={() => {
          trackSendToAppDownloadButtonTapped('webOnboarding');
        }}
      >
        <Flex margin={'5'} direction={'column'}>
          <Text marginTop={'5'} fontSize={'20px'} as={'b'}>
            1. Download the App
          </Text>
          <Flex direction={'row'} alignItems={'center'}>
            <Flex width={'70px'} height={'70px'} marginTop={'2'}>
              <Image
                src={pushInfo.artworkUrl512}
                borderRadius={'2xl'}
                width={'100%'}
                backgroundColor={'dripSecondaryFill'}
              ></Image>
            </Flex>
            <Flex direction={'column'} marginLeft={'3'}>
              <Text fontSize={'18px'}>{pushInfo.trackName}</Text>
              <Text fontSize={'14px'} color={'lightGray'}>
                Interval run timer and coach
              </Text>
            </Flex>
            <Button
              bgColor={'tintColor'}
              marginLeft={'5'}
              borderRadius={'2xl'}
              color={'white'}
              height={'30px'}
            >
              Open
            </Button>
          </Flex>
          <Flex
            direction={'row'}
            marginTop={'5'}
            justifyContent={'space-between'}
          >
            <Flex alignItems={'center'} color={'lightGray'}>
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <StarIcon marginRight={'1'} />
              <Text marginLeft={'1'} color={'lightGray'}>
                {pushInfo.userRatingCountForCurrentVersion}
              </Text>
            </Flex>
            <Text marginRight={'3'} color={'lightGray'}>
              Health & Fitness
            </Text>
          </Flex>
        </Flex>
      </Link>
      <Flex direction={'column'} margin={'5'}>
        <Text marginTop={'5'} fontSize={'20px'} as={'b'}>
          2. Once downloaded, sync your progress
        </Text>
        <Text margin={'2'} color={'lightGray'}>
          After the app has finished downlaoding, click below to pick up right
          where you left off!
        </Text>
      </Flex>

      <Flex justifyContent={'center'} marginLeft={'5'} marginRight={'5'}>
        <Button
          width={'100%'}
          bgColor={isContinueButtonBright ? 'tintColor' : 'dripSecondaryFill'}
          color={'white'}
          borderRadius={'3xl'}
          size={'lg'}
          boxShadow="lg"
          _hover={{}}
          _focus={{}}
          _active={{}}
          onClick={handleDeepLinkButtonClick}
        >
          Load profile in app
        </Button>
      </Flex>
    </Container>
  );
});

export default SendToApp;
